import {
  SIGNUP_START,
  SIGNUP_COMPLETE,
  SIGNUP_ERROR,
  INSTAGRAM_LOGIN_START,
  INSTAGRAM_LOGIN_COMPLETE,
  INSTAGRAM_LOGIN_ERROR,
  EMAIL_ERROR,
  PASSWORD_ERROR,
  CLEAR_EMAIL_ERROR,
  CLEAR_PASSWORD_ERROR,
  CLEAR_SIGNUP_ERROR,
  USER_IS_LOGGED_IN,
  USER_IS_NOT_LOGGED_IN,
} from 'constants/types';

const initialState = {
  signupStart: false,
  signupErrorMessage: '',
  instagramLoginStart: false,
  instagramLoginError: false,
  emailError: false,
  emailErrorMessage: '',
  passwordError: false,
  passwordErrorMessage: '',
  isLoggedIn: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP_START: {
      return {
        ...state,
        signupStart: true,
      }
    }
    case SIGNUP_COMPLETE: {
      return {
        ...state,
        signupStart: false,
        signupErrorMessage: '',
        emailError: false,
        passwordError: false,
      }
    }
    case SIGNUP_ERROR: {
      return {
        ...state,
        signupStart: false,
        signupErrorMessage: action.payload,
      }
    }
    case EMAIL_ERROR: {
      return {
        ...state,
        signupStart: false,
        emailError: true,
        emailErrorMessage: action.payload,
      }
    }
    case PASSWORD_ERROR: {
      return {
        ...state,
        signupStart: false,
        passwordError: true,
        passwordErrorMessage: action.payload,
      }
    }
    case CLEAR_EMAIL_ERROR: {
      return {
        ...state,
        emailError: false,
        emailErrorMessage: '',
      }
    }
    case CLEAR_PASSWORD_ERROR: {
      return {
        ...state,
        passwordError: false,
        passwordErrorMessage: '',
      }
    }
    case CLEAR_SIGNUP_ERROR: {
      return {
        ...state,
        signupErrorMessage: '',
      }
    }
    case USER_IS_LOGGED_IN: {
      return {
        ...state,
        isLoggedIn: true,
      }
    }
    case USER_IS_NOT_LOGGED_IN: {
      return {
        ...state,
        isLoggedIn: false,
      }
    }
    case INSTAGRAM_LOGIN_START: {
      return {
        ...state,
        instagramLoginStart: true,
        instagramLoginError: false,
      }
    }
    case INSTAGRAM_LOGIN_COMPLETE: {
      return {
        ...state,
        instagramLoginStart: false,
        instagramLoginError: false,
      }
    }
    case INSTAGRAM_LOGIN_ERROR: {
      return {
        ...state,
        instagramLoginStart: false,
        instagramLoginError: true,
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/session.js